import {useDispatch} from "react-redux";
import {useHistory} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import {responseHandler, sendData, socket} from "../../../store/actions";
import Layout from "../../../components/layout/Layout";
import {getLabelValue} from "../../../common/functions";
import {constant, REGEX} from "../../../common/constant";
import AppHeader from "../../common/components/app-header";
import UInput from "../../../common/component/UInput";
import * as Icon from "ubs-icons"
import Validator from "simple-react-validator";
import {useForceUpdate} from "../../common/useForceUpdate";
import UPopup from "../../../common/component/UPopup";
import UCountryMobile from "../../../common/component/UCountryMobile";
import Select from "react-select";
import {UToggleSwitch} from "ubs-framework"
import {spiltContact} from "../../../common/common";
import Commonrightcircle from "../../../common/component/RightCircle/commonrightcircle";
import useSocket from "../../common/useSocket";
import {withRouter} from "../../../common/hocs/routing-hoc";

function Registration(props) {
    const dispatch = useDispatch();
    const history = useHistory();

    const forceUpdate = useForceUpdate()
    const validator = useRef(new Validator({
        element: (message, className) => <div className="u_error_message">{message}</div>,
        autoForceUpdate: {forceUpdate},
        validators: {
            uppercase: {  // name the rule
                message: 'Please use uppercase.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.upperCase) && params.indexOf(val) === -1
                },
            },
            lowercase: {  // name the rule
                message: 'Please use lowercase.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.lowerCase) && params.indexOf(val) === -1
                },
            },
            specialcase: {  // name the rule
                message: 'Please use one special character.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.specialChar) && params.indexOf(val) === -1
                },
            },
            number: {  // name the rule
                message: 'Please use one number.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.number) && params.indexOf(val) === -1
                },
            },
        }
    }));

    const [activeTab, setActiveTab] = useState("aboutYou"); // aboutYou, aboutCompany
    const [errorMsg, setErrorMsg] = useState("");
    const [disabledBtn, setDisabledBtn] = useState(false);
    const [showTogglePopup, setShowTogglePopup] = useState(false);
    // const [passwordEye, setPasswordEye] = useState(false)
    const [toggle, setToggle] = useState(true)
    const [registerDetail, setRegisterDetail] = useState({
        firstName: "",
        lastName: "",
        email: "",
        // password: "",
    });
    const [fieldValues, setAllFieldValues] = useState({
        company: "",
        country: "",
        phoneNumberCC: "",
        phoneNumber: "",
        selectedEmployee: {value: "1-5", label: "1-5"},
    })
    const [countryOptions, setCountryOptions] = useState([]);
    const {on, off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'addressParams':
                    if (res?.data?.results?.length) {
                        if (res.data?.type === 'country') {
                            setCountryOptions(getLabelValue(res?.data?.results))
                        }
                    }
                    break;
                default:
                    return true;
            }
        }
    })

    useEffect(() => {
        on();
        return () => off()
    }, [])
    useEffect(() => {
        sendData(dispatch, 'addressParams', {})
        socket.on("response", (response) => {
            let res = responseHandler(response);
            if (!res.error) {
                setDisabledBtn(false)
                switch (res.event) {
                    case 'checkEmailExistense': {
                        if (res.data.exists) {
                            setErrorMsg("An account with this email address already exists. Login or Register with different email")
                        } else {
                            setActiveTab("aboutCompany");
                        }
                        break;
                    }
                    case "activateAccount": {
                        localStorage.clear('affiliatecode')
                        localStorage.clear('usercode')
                        history.push("/stay-tuned");
                        break;
                    }
                    default:
                        return true;
                }
            } else {
                setErrorMsg(res.data.error);
                setTimeout(() => setErrorMsg(res.data.error), 5000);
            }
        });
    }, []);


    const inputEvent = (e) => {
        let {name, value} = e.target
        setRegisterDetail((val) => {
            return {...val, [name]: value}
        })
    }

    const handle = {
        inputField: e => {
            setAllFieldValues({...fieldValues, [e.target.name]: e.target.value});
        },
        phoneField: e => {
            setAllFieldValues({...fieldValues, phoneNumber: e.phone, phoneNumberCC: e.code});
        },
        employeeCount: e => {
            setAllFieldValues({...fieldValues, selectedEmployee: e})
        },
        selectedCountry: e => {
            setAllFieldValues({...fieldValues, country: e});
        }
    }
    const onSubmitAboutYou = () => {
        if (validator?.current?.allValid()) {
            setDisabledBtn(true)
            const data = {email: registerDetail?.email};
            sendData(dispatch, 'checkEmailExistense', data);
        } else {
            validator?.current?.showMessages()
        }
    };

    const onSubmitAboutCompany = () => {
        const number = fieldValues?.phoneNumber.split("-")
        let affiliatecode = localStorage.getItem('affiliatecode')
        let usercode = localStorage.getItem('usercode')
        const sendDetail = {
            firstName: registerDetail?.firstName,
            lastName: registerDetail?.lastName,
            email: registerDetail?.email,
            // password: registerDetail?.password,
            company: fieldValues?.company,
            phone: number[1],
            numemployees: fieldValues?.selectedEmployee?.value,
            country: fieldValues?.country?.label
        }
        if (affiliatecode) sendDetail.affiliatecode = affiliatecode
        if (usercode) sendDetail.usercode = usercode

        if (validator?.current?.allValid() && toggle) {
            setDisabledBtn(true);
            dispatch({type: 'SET_EMAIL', payload: registerDetail?.email});
            sendData(dispatch, 'signUp', sendDetail);
        } else {
            if (!toggle) {
                setShowTogglePopup(true)
                setTimeout(() => setShowTogglePopup(false), 1000)
            }
            validator?.current?.showMessages()
        }
    };


    const handleToggle = () => {
        setToggle(!toggle)
    }
    return (
        <React.Fragment>
            <Layout module="register">
                <div className="u_account-form">
                    <Commonrightcircle/>
                    <AppHeader header="Create New Account"
                               title={`${activeTab === "aboutYou" ? "Let's register and connect with your co-workers to get the things done together and faster." : "You are just one step away to signup and enable the way to communicate faster."}`}/>
                </div>

                <div className="u_account-form">
                    <UInput
                        hasError={validator?.current?.message("firstName", registerDetail?.firstName, "required")}
                        className="u_mb-20" label="First Name" asterisk>
                        <input name="firstName" value={registerDetail?.firstName} onChange={inputEvent} placeholder=" "
                               autoComplete="off"/>
                    </UInput>
                    <UInput
                        hasError={validator?.current?.message("lastName", registerDetail?.lastName, "required")}
                        className="u_mb-20" label="Last Name" asterisk>
                        <input name="lastName" value={registerDetail?.lastName} onChange={inputEvent} placeholder=" "
                               autoComplete="off"/>
                    </UInput>
                    <UInput hasError={validator?.current?.message("email", registerDetail?.email, "required|email")}
                            className="u_mb-20" label="Email Address" asterisk>
                        <input name="email" value={registerDetail?.email} onChange={inputEvent} placeholder=" "/>
                    </UInput>

                    {errorMsg.length !== 0 && (
                        <p className="u_error-message u_mb-15">{errorMsg}</p>
                    )}
                    {/*<div className="u_block u_relative">*/}
                    {/*    <button disabled={disabledBtn} type="button" onClick={onSubmitAboutYou}*/}
                    {/*            className={`u_account-btn u_w-full u_cp ${disabledBtn && 'u_white'}`}>Next*/}
                    {/*    </button>*/}
                    {/*    {disabledBtn && <div className="u_btn-loader"><Icon.Preloader size={70}/></div>}*/}
                    {/*</div>*/}

                </div>
                <div className="u_account-form">
                    <UInput
                        selectValue={fieldValues?.company}
                        hasError={validator?.current?.message("company", fieldValues?.company, "required")}
                        className="u_mb-20" label="Company Name" asterisk>
                        <input name="company" value={fieldValues?.company}
                               autoComplete="off"
                               onChange={handle.inputField}
                               placeholder=" "/>
                    </UInput>
                    <UInput label="Phone Number"
                            className="u_mb-20" isFocused asterisk
                            hasError={validator?.current?.message("phoneNumber", spiltContact(fieldValues?.phoneNumber)[1], "required|number")}>
                        <UCountryMobile code={fieldValues?.phoneNumberCC} phone={fieldValues?.phoneNumber}
                                        onChange={handle.phoneField}/>
                    </UInput>
                    <UInput
                        hasError={validator?.current?.message("selectedEmployee", fieldValues?.selectedEmployee, "required")}
                        label="Employee Count" className="u_mb-20" selectValue={fieldValues?.selectedEmployee}
                        select asterisk>
                        <Select
                            className="u_input-select-inner"
                            classNamePrefix="u_select"
                            options={constant?.EMP_COUNT}
                            defaultValue={fieldValues?.selectedEmployee}
                            value={fieldValues?.selectedEmployee}
                            onChange={handle.employeeCount}
                            maxMenuHeight={120}
                        />
                    </UInput>
                    {/*<UInput hasError={validator?.current?.message("country", fieldValues?.country, "required")}
                            label="Country" className="u_mb-20" selectValue={fieldValues?.country} select asterisk>
                        <Select
                            className="u_input-select-inner"
                            classNamePrefix="u_select"
                            options={countryOptions}
                            placeholder=" "
                            value={fieldValues?.country}
                            name='country'
                            onChange={handle?.selectedCountry}
                            maxMenuHeight={120}
                        />
                    </UInput>*/}
                    <div className="u_mb-20 u_flex u_toggle-status">
                        <UPopup showDefault={showTogglePopup} params={{className: "u_tooltip"}}
                                desc={<span>Please agree with Terms & Conditions and Privacy Policy</span>}>
                            <span><UToggleSwitch id="123" checked={toggle} onChange={handleToggle}/></span></UPopup><h2
                        className="u_ml-10">Agree
                        with <a href="https://superworks.com/terms-and-conditions" target="_blank">Terms & Condition </a> and <a
                            href="https://superworks.com/privacy-policy" target="_blank"> Privacy Policy</a></h2>
                    </div>

                    <div className="u_block u_relative">
                        <button disabled={disabledBtn} type="button" onClick={onSubmitAboutCompany}
                                className={`u_account-btn u_w-full u_cp ${disabledBtn && 'u_white'}`}>Sign Up
                        </button>
                        {disabledBtn &&
                        <div className="u_btn-loader"><Icon.Preloader size={70}/></div>}
                    </div>
                </div>
            </Layout>
        </React.Fragment>
    );
}

export default withRouter(Registration);
